import type {
  ActiveTab,
  Dialog,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog,
} from '@common/types'
import { stringify as stringifyQs } from 'qs'
import urlJoin from 'url-join'

export const settingsSection = '/settings/'

export const campaignListPath = 'campaigns'
export const campaignRoutingOverviewPath = 'campaign-routing-overview'
export const caseActionTypeListPath = 'action-types'
export const caseActionResultListPath = 'action-results'
export const caseCloseReasonListPath = 'close-reasons'
export const caseTypeListPath = 'case-types'
export const caseTagListPath = 'case-tags'
export const financialAccountTypeListPath = 'financial-account-types'
export const ticketActionResultListPath = 'ticket-action-results'
export const ticketActionTypeListPath = 'ticket-action-types'
export const ticketCloseReasonListPath = 'ticket-close-reasons'
export const ticketTagListPath = 'ticket-tags'
export const productListPath = 'products'
export const productPackageListPath = 'product-packages'

export enum SettingsUrlSortField {
  active = 'active',
  name = 'name',
}

export type SettingsUrlDialog = 'cancel' | 'new' | TabActionDialog

export type SettingsUrlSort = Sort<SettingsUrlSortField>
export type SettingsUrlQueryParams = Dialog<SettingsUrlDialog> &
  SettingsUrlSort &
  Pagination &
  ActiveTab

export const settingsListUrl =
  (typePath: string) =>
  (params?: SettingsUrlQueryParams): string => {
    const caseList = urlJoin(settingsSection, typePath)
    if (params === undefined) {
      return caseList
    } else {
      return urlJoin(caseList, '?' + stringifyQs(params))
    }
  }

export const campaignDetailPath = 'campaign'
export const campaignResolverDetailPath = 'campaign-rule'
export const caseActionTypeDetailPath = 'action-type'
export const caseActionResultDetailPath = 'action-result'
export const caseCloseReasonDetailPath = 'close-reason'
export const caseTypeDetailPath = 'case-type'
export const caseTagDetailPath = 'case-tag'
export const financialAccountTypeDetailPath = 'financial-account-type'
export const ticketActionResultDetailPath = 'ticket-action-result'
export const ticketActionTypeDetailPath = 'ticket-action-type'
export const ticketCloseReasonDetailPath = 'ticket-close-reason'
export const ticketTagDetailPath = 'ticket-tag'
export const productDetailPath = 'product'
export const productPackageDetailPath = 'product-package'

export const settingsPath = (typePath: string, id: string) => urlJoin(settingsSection, typePath, id)

export type SettingsItemDetailUrlDialog = 'cancel' | 'delete'

export type SettingsItemDetailUrlQueryParams = Dialog<SettingsItemDetailUrlDialog> & SingleAction

export type ProductPackageDetailUrlDialog =
  | SettingsItemDetailUrlDialog
  | 'document-type-create'
  | 'document-type-edit'
  | 'document-type-delete'
  | 'document-type-upload'

export type ProductPackageDetailTab = 'documents' | 'rules'

export type ProductPackageDetailUrlQueryParams = Dialog<ProductPackageDetailUrlDialog> &
  SingleAction &
  Partial<{ documentTypeId: string; tab: ProductPackageDetailTab }>

export const settingsDetailsUrl =
  (typePath: string) => (id: string, params?: SettingsItemDetailUrlQueryParams) =>
    settingsPath(typePath, encodeURIComponent(id)) + '?' + stringifyQs(params)

export const productPackageDetailsUrl = (id: string, params?: ProductPackageDetailUrlQueryParams) =>
  settingsPath(productPackageDetailPath, encodeURIComponent(id)) + '?' + stringifyQs(params)
